import _objectSpread from'@babel/runtime/helpers/objectSpread2';import _extends from'@babel/runtime/helpers/extends';import _objectWithoutProperties from'@babel/runtime/helpers/objectWithoutProperties';import React from'react';import PropTypes from'prop-types';import {useHistory}from'react-router-dom';import usePathBuilder from'../../hooks/usePathBuilder.js';import CoBrandingButton from'../CoBranding/CoBrandingButton.js';function CIAMLinkButton(props) {
  var to = props.to,
    children = props.children,
    otherProps = _objectWithoutProperties(props, ["to", "children"]);
  var history = useHistory();
  var pathBuilder = usePathBuilder();
  return /*#__PURE__*/React.createElement(CoBrandingButton, _extends({}, otherProps, {
    onClick: function onClick() {
      return history.push(pathBuilder(to));
    }
  }), children);
}
process.env.NODE_ENV !== "production" ? CIAMLinkButton.propTypes = _objectSpread(_objectSpread({}, CoBrandingButton.propTypes), {}, {
  to: PropTypes.string.isRequired
}) : void 0;export{CIAMLinkButton as default};